// The version shown in the corner of every page. The release number (r1, r2, ...) goes up by one with every release, so it is
// easy to tell which build someone is looking at. Record each release's Railway deployment id in CLAUDE.md.
export const APP_VERSION = 'v2.2r11';
